<template>
    <div>
        <table class="courseInfoTable"
            v-if="noAuthPlanCodeArray.indexOf(courseInfoArray[n-1].planCode) < 0"
            v-for="n in courseInfoArray.length">
            <tr>
                <td class="courseName" :rowspan="courseInfoArray[n-1].week.length">{{ courseInfoArray[n-1].courseName }}</td>
                <td class="courseInfo"
                    @mouseover="handleMouseOver"
                    @mouseout="handleMouseOut"
                    @click="handleClick('week', (n-1)+'_'+0)">{{ formatWeekShow(courseInfoArray[n-1].week[0]) }}</td>
                <td class="courseInfo"
                    @mouseover="handleMouseOver"
                    @mouseout="handleMouseOut"
                    @click="handleClick('tea', (n-1)+'_'+0)">{{ courseInfoArray[n-1].teaName[0].replace(/\+/g, '、') }}</td>
                <td class="courseInfo"
                    @mouseover="handleMouseOver"
                    @mouseout="handleMouseOut"
                    @click="handleClick('site', (n-1)+'_'+0)">{{ courseInfoArray[n-1].siteName[0].replace(/\+/g, '、') }}</td>
            </tr>
            <tr v-if="courseInfoArray[n-1].week.length > 1" v-for="m in courseInfoArray[n-1].week.length-1">
                <td class="courseInfo"
                    @mouseover="handleMouseOver"
                    @mouseout="handleMouseOut"
                    @click="handleClick('week', (n-1)+'_'+m)">{{ formatWeekShow(courseInfoArray[n-1].week[m]) }}</td>
                <td class="courseInfo"
                    @mouseover="handleMouseOver"
                    @mouseout="handleMouseOut"
                    @click="handleClick('tea', (n-1)+'_'+m)">{{ courseInfoArray[n-1].teaName[m].replace(/\+/g, '、') }}</td>
                <td class="courseInfo"
                    @mouseover="handleMouseOver"
                    @mouseout="handleMouseOut"
                    @click="handleClick('site', (n-1)+'_'+m)">{{ courseInfoArray[n-1].siteName[m].replace(/\+/g, '、') }}</td>
            </tr>
        </table>
        <div slot="footer" class="dialog-footer" style="float:right; margin-top:10px">
            <el-tooltip class="item" effect="dark" content="仅修改当前位置课程信息" placement="top">
                <el-button type="primary" @click="save">保存</el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="同步修改当前班级所有相同课程信息" placement="top">
                <el-button type="primary" @click="batchSave">保存（同步）</el-button>
            </el-tooltip>
            <el-button @click="closeDialog">取消</el-button>
        </div>

        <el-dialog title="上课周次设置"
            :visible.sync="weekSettingDialogVisible"
            v-if="weekSettingDialogVisible"
            width="450px" top="100px" append-to-body>
            <div style="height:480px;">
                <weekSetting ref="weekSetting"
                    @updateWeekInfo="updateWeekInfo"
                    @closeWeekSettingDialog="closeWeekSettingDialog">
                </weekSetting>
            </div>
        </el-dialog>

        <el-dialog title="授课教师设置"
            :visible.sync="teaSettingDialogVisible"
            v-if="teaSettingDialogVisible"
            width="600px" top="250px" append-to-body>
            <div :style="{ height:teaSettingDialogHeight + 'px' }">
                <teaSetting ref="teaSetting"
                    @updateTeaInfo="updateTeaInfo"
                    @updateTeaDialogHeight="updateTeaDialogHeight"
                    @closeTeaSettingDialog="closeTeaSettingDialog">
                </teaSetting>
            </div>
        </el-dialog>

        <el-dialog title="授课场地设置"
            :visible.sync="siteSettingDialogVisible"
            v-if="siteSettingDialogVisible"
            width="600px" top="250px" append-to-body>
            <div :style="{ height:siteSettingDialogHeight + 'px' }">
                <siteSetting ref="siteSetting"
                    @updateSiteInfo="updateSiteInfo"
                    @updateSiteDialogHeight="updateSiteDialogHeight"
                    @closeSiteSettingDialog="closeSiteSettingDialog">
                </siteSetting>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";
    import * as commonTools from "utils/timetableCommon";
    import weekSetting from 'views/timetableManage/arrange/weekSetting.vue';
    import teaSetting from 'views/timetableManage/arrange/teaSetting.vue';
    import siteSetting from 'views/timetableManage/arrange/siteSetting.vue';

    export default {
        components: {
            weekSetting,
            teaSetting,
            siteSetting,
        },
        data() {
            return {
                queryForm: {
                    semesterCode: null,
                    classCode: null,
                },
                cellInfo: null,
                courseInfoArray: [],
                teachingWeekNum: 0,
                oddWeekArray: [],
                evenWeekArray: [],
                noAuthPlanCodeArray: null,
                curEditType: null,
                curEditIndex: [0, 0],
                weekSettingDialogVisible: false,
                teaSettingDialogVisible: false,
                teaSettingDialogHeight: 190,
                siteSettingDialogVisible: false,
                siteSettingDialogHeight: 190,
            }
        },
        mounted() {
        },
        methods: {
            parseCourseInfo(){
                let planCodeArray_1 = this.cellInfo.planCode.split('｜');
                let courseCodeArray_1 = this.cellInfo.courseCode.split('｜');
                let courseNameArray_1 = this.cellInfo.courseName.split('｜');
                let courseTypeCodeArray_1 = this.cellInfo.courseTypeCode.split('｜');
                let deptCodeArray_1 = this.cellInfo.deptCode.split('｜');
                let teaCodeArray_1 = this.cellInfo.teaCode.split('｜');
                let teaNameArray_1 = this.cellInfo.teaName.split('｜');
                let siteCodeArray_1 = this.cellInfo.siteCode.split('｜');
                let siteNameArray_1 = this.cellInfo.siteName.split('｜');
                let weekArray_1 = this.cellInfo.week.split('｜');
                let weekDetailArray_1 = this.cellInfo.weekDetail.split('｜');
                let rowNum = 0;

                for(let i=0; i<planCodeArray_1.length; i++){
                    let teaCodeArray_2 = teaCodeArray_1[i].split("&");
                    if(this.noAuthPlanCodeArray.indexOf(planCodeArray_1[i]) < 0){
                         rowNum += teaCodeArray_2.length;
                    }

                    let courseInfo = {
                        planCode: planCodeArray_1[i],
                        courseCode: courseCodeArray_1[i],
                        courseName: courseNameArray_1[i],
                        courseTypeCode: courseTypeCodeArray_1[i],
                        deptCode: deptCodeArray_1[i],
                        teaCode: teaCodeArray_2,
                        teaName: teaNameArray_1[i].split("&"),
                        siteCode: siteCodeArray_1[i].split("&"),
                        siteName: siteNameArray_1[i].split("&"),
                        week: weekArray_1[i].split("&"),
                        weekDetail: weekDetailArray_1[i].split("&"),
                    };

                    this.courseInfoArray.push(courseInfo);
                }

                this.$emit('updateCourseSettingDialogHeight', 50 * rowNum + 70);
            },
            formatWeekShow(week){
                return commonTools.formatWeekShow(week, this.oddWeekArray, this.evenWeekArray);
            },
            handleClick(type, index){
                this.curEditType = type;
                const tempIndex = index.split('_');
                this.curEditIndex = [parseInt(tempIndex[0], 10), parseInt(tempIndex[1], 10)];

                if(type === 'week'){
                    this.showWeekSetting();
                }else if(type === 'tea'){
                    this.showTeaSetting();
                }else if(type === 'site'){
                    this.showSiteSetting();
                }
            },
            handleMouseOver(ele){
                $(ele.srcElement).css('background-color', '#FFE48D');
            },
            handleMouseOut(ele){
                $(ele.srcElement).css('background-color', '#FFFFFF');
            },
            showWeekSetting(){
                this.weekSettingDialogVisible = true;

                this.$nextTick().then(() => {
                    this.$refs.weekSetting.queryForm.semesterCode = this.queryForm.semesterCode;
                    this.$refs.weekSetting.queryForm.classCode = this.queryForm.classCode;
                    this.$refs.weekSetting.queryForm.timeOrder = this.cellInfo.timeOrder;
                    this.$refs.weekSetting.teachingWeekNum = this.teachingWeekNum;
                    this.$refs.weekSetting.oddWeekArray = this.oddWeekArray;
                    this.$refs.weekSetting.evenWeekArray = this.evenWeekArray;
                    //获取课程详细信息
                    this.$refs.weekSetting.curCellWeekInfo = commonTools.convertWeekStrToArray(this.cellInfo.week);
                    this.$refs.weekSetting.curWeekInfo = commonTools.convertWeekStrToArray(this.courseInfoArray[this.curEditIndex[0]].week[this.curEditIndex[1]]);
                    this.$refs.weekSetting.queryForm.teaCode = this.courseInfoArray[this.curEditIndex[0]].teaCode[this.curEditIndex[1]];
                    this.$refs.weekSetting.queryForm.siteCode = this.courseInfoArray[this.curEditIndex[0]].siteCode[this.curEditIndex[1]];
                    this.$refs.weekSetting.queWeekUsedInfo();
                });
            },
            updateWeekInfo(weekInfo){
                this.weekSettingDialogVisible = false;
                this.courseInfoArray[this.curEditIndex[0]].week[this.curEditIndex[1]] = weekInfo;
                this.courseInfoArray[this.curEditIndex[0]].weekDetail[this.curEditIndex[1]] = commonTools.convertWeekStrWithMark(weekInfo, '#');
                this.cellInfo.week = this.jointInfo('week');
                this.cellInfo.weekDetail = this.jointInfo('weekDetail');
            },
            jointInfo(propName){
                let finalStr = '';

                for(let i=0; i<this.courseInfoArray.length; i++){
                    for(let j=0; j<this.courseInfoArray[i][propName].length; j++){
                        finalStr += this.courseInfoArray[i][propName][j] + '&';
                    }
                    finalStr = finalStr.substring(0, finalStr.length-1);
                    finalStr += '｜';
                }
                finalStr = finalStr.substring(0, finalStr.length-1);

                return finalStr;
            },
            closeWeekSettingDialog(){
                this.weekSettingDialogVisible = false;
            },
            showTeaSetting(){
                this.teaSettingDialogVisible = true;

                this.$nextTick().then(() => {
                    this.$refs.teaSetting.queryForm.semesterCode = this.queryForm.semesterCode;
                    this.$refs.teaSetting.queryForm.classCode = this.queryForm.classCode;
                    this.$refs.teaSetting.queryForm.timeOrder = this.cellInfo.timeOrder;
                    this.$refs.teaSetting.teaCode = this.courseInfoArray[this.curEditIndex[0]].teaCode[this.curEditIndex[1]];
                    this.$refs.teaSetting.queryForm.week = commonTools.convertWeekStrWithMark(this.courseInfoArray[this.curEditIndex[0]].week[this.curEditIndex[1]], '#');
                    this.$refs.teaSetting.oriTeaCode = this.courseInfoArray[this.curEditIndex[0]].teaCode[this.curEditIndex[1]];
                    this.$refs.teaSetting.oriTeaName = this.courseInfoArray[this.curEditIndex[0]].teaName[this.curEditIndex[1]].replace(/\+/g, '、');
                    this.$refs.teaSetting.teaCodeArray = this.$refs.teaSetting.oriTeaCode.split("+");
                    this.$refs.teaSetting.queTeaCombo();
                });
            },
            updateTeaInfo(teaInfo){
                this.teaSettingDialogVisible = false;
                this.courseInfoArray[this.curEditIndex[0]].teaCode[this.curEditIndex[1]] = teaInfo.teaCode;
                this.courseInfoArray[this.curEditIndex[0]].teaName[this.curEditIndex[1]] = teaInfo.teaName;
                this.cellInfo.teaCode = this.jointInfo('teaCode');
                this.cellInfo.teaName = this.jointInfo('teaName');
            },
            updateTeaDialogHeight(height){
                this.teaSettingDialogHeight = height;
            },
            closeTeaSettingDialog(){
                this.teaSettingDialogVisible = false;
            },
            showSiteSetting(){
                this.siteSettingDialogVisible = true;

                this.$nextTick().then(() => {
                    this.$refs.siteSetting.queryForm.semesterCode = this.queryForm.semesterCode;
                    this.$refs.siteSetting.queryForm.classCode = this.queryForm.classCode;
                    this.$refs.siteSetting.queryForm.deptCode = this.courseInfoArray[this.curEditIndex[0]].deptCode;
                    this.$refs.siteSetting.queryForm.timeOrder = this.cellInfo.timeOrder;
                    this.$refs.siteSetting.queryForm.siteCode = this.courseInfoArray[this.curEditIndex[0]].siteCode[this.curEditIndex[1]];
                    this.$refs.siteSetting.queryForm.week = commonTools.convertWeekStrWithMark(this.courseInfoArray[this.curEditIndex[0]].week[this.curEditIndex[1]], '#');
                    this.$refs.siteSetting.oriSiteCode = this.courseInfoArray[this.curEditIndex[0]].siteCode[this.curEditIndex[1]];
                    this.$refs.siteSetting.oriSiteName = this.courseInfoArray[this.curEditIndex[0]].siteName[this.curEditIndex[1]].replace(/\+/g, '、');
                    this.$refs.siteSetting.siteCodeArray = this.$refs.siteSetting.oriSiteCode.split("+");
                    this.$refs.siteSetting.queSiteCombo();
                });
            },
            updateSiteInfo(siteInfo){
                this.siteSettingDialogVisible = false;
                this.courseInfoArray[this.curEditIndex[0]].siteCode[this.curEditIndex[1]] = siteInfo.siteCode;
                this.courseInfoArray[this.curEditIndex[0]].siteName[this.curEditIndex[1]] = siteInfo.siteName;
                this.cellInfo.siteCode = this.jointInfo('siteCode');
                this.cellInfo.siteName = this.jointInfo('siteName');
            },
            updateSiteDialogHeight(height){
                this.siteSettingDialogHeight = height;
            },
            closeSiteSettingDialog(){
                this.siteSettingDialogVisible = false;
            },
            //关闭对话框
            closeDialog() {
                this.$emit('closeChangeCourseInfoDialog');
            },
            save() {
                this.$emit('updateChangeCourseInfo', this.cellInfo);
            },
            batchSave(){
                this.$emit('batchUpdateChangeCourseInfo', this.cellInfo);
            },
        },
    }
</script>

<style scoped>
    .courseInfoTable {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        margin-top: 2px;
    }

    .courseInfoTable tr {
        height: 50px;
    }

    .courseName {
        width: 28%;
        font-weight: bold;
        padding-left: 10px;
        background-color: #F1FAF6;
        border: 1px solid #DCDFE6;
    }

    .courseInfo {
        width: calc(72% / 3);
        padding-left: 10px;
        border: 1px solid #DCDFE6;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// courseSetting.vue?0e29c9ce